import { api } from "@shared/lib/api";
import { BackednResponse } from "@shared/lib/types";
import {
  GetAccounting,
  ICreateBrandAccounting,
  IGetAccountingParams,
  IInvoiceById,
  IInvoicingAggregates,
} from "@shared/lib/types/accounting";
import {
  ICreatePayment,
  ICreatePurchase,
  ICreditNoteOnInvoice,
  IPayments,
  IPurchases,
} from "../types";

export class AccountingService {
  public static async getBrandInvoices(params: IGetAccountingParams) {
    const url = `billing/brand/accounting/search`;
    const response = (await api
      .post(url, { json: params })
      .json()) as BackednResponse<GetAccounting>;
    return response;
  }
  public static async getInvoiceById(id: string) {
    const url = `billing/brand/accounting/search/by-id`;
    const response = (await api
      .post(url, { json: { brandAccountingId: id } })
      .json()) as BackednResponse<IInvoiceById>;
    return response;
  }

  public static async getBrandInvoicesAggregates(
    params: Partial<IGetAccountingParams>
  ) {
    const url = `billing/brand/accounting/search/aggregates`;
    const response = (await api
      .post(url, { json: params })
      .json()) as BackednResponse<IInvoicingAggregates>;
    return response;
  }

  public static async getPurchases(payload: {
    pageNo: number;
    limit: number;
    searchQuery?: string;
    brandIds?: string[];
    briefIds?: string[];
    type?: string[];
    subType?: string[];
    category?: string[];
    createdAtFrom?: string;
    createdAtTo?: string;
    accountingFillingStatus?: string[];
    accountingIds?: string[];
  }) {
    const { createdAtFrom, createdAtTo } = payload;
    const searchUrl = `billing/brand/ledger/search`;
    return (await api
      .post(searchUrl, {
        json: {
          ...payload,
          createdAt: {
            from: createdAtFrom,
            to: createdAtTo,
          },
        },
      })
      .json()) as BackednResponse<IPurchases>;
  }

  public static async raiseCreditNoteOnInvoice(data: ICreditNoteOnInvoice) {
    const url = "billing/brand/accounting/credit-note";
    const response = await api
      .put(url, {
        json: { ...data },
      })
      .json();
    return response;
  }

  public static async createBrandAccounting(data: ICreateBrandAccounting) {
    const url = `billing/brand/accounting`;
    const response = await api.put(url, { json: data }).json();
    return response;
  }

  public static async createPurchase(data: ICreatePurchase) {
    const url = "billing/brand/ledger";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }

  public static async createPayment(data: ICreatePayment) {
    const url = "billing/brand/accounting-payments";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }

  public static async getPayments(payload: {
    pageNo: number;
    limit: number;
    searchQuery?: string;
    brandIds?: string[];
    subTypes?: string[];
  }) {
    const searchUrl = `billing/brand/accounting-payments/search`;
    return (await api
      .post(searchUrl, {
        json: {
          ...payload,
        },
      })
      .json()) as BackednResponse<IPayments>;
  }

  public static async downloadAccounting(data: {
    accountingDate: {
      from: string;
      to: string;
    };
  }) {
    const url = `download/brandAccounting`;
    const response = (await api
      .post(url, { json: data })
      .json()) as BackednResponse<void>;
    return response;
  }
}
